module.exports = __webpack_public_path__ + "img/caselist18.de341cf9.jpg";